// DoctorRoutes.js
import React from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import Header from "../components/header";
import FooterV2 from "../components/FooterV2";
import { Roles } from "../constants";

function DoctorRoutes() {
  return (
    <>
      <AuthGuard role={Roles.DENTIST}>
        <Header />
        <Outlet />
        <FooterV2 />
      </AuthGuard>
    </>
  );
}

export default DoctorRoutes;
